// extracted by mini-css-extract-plugin
module.exports = {"views":"Views_views__1sQWh","ratechange":"Views_ratechange__xeTF4"};